import React, { FunctionComponent } from 'react';
import type { Region } from './types';

const REGIONS: Region[] = [
  {
    name: '北海道・東北', path: '/tohoku', prefectures: [
      { name: '北海道', path: '/hokkaido', cities: [{ name: '札幌市', path: '/sapporo-city' }] },
      { name: '青森県', path: '/aomori', cities: [] },
      { name: '岩手県', path: '/iwate', cities: [] },
      { name: '宮城県', path: '/miyagi', cities: [{ name: '仙台市', path: '/sendai-city' }] },
      { name: '秋田県', path: '/akita', cities: [] },
      { name: '山形県', path: '/yamagata', cities: [] },
      { name: '福島県', path: '/fukushima', cities: [] },
    ],
  },
  {
    name: '関東', path: '/kanto', prefectures: [
      { name: '茨城県', path: '/ibaraki', cities: [] },
      { name: '栃木県', path: '/tochigi', cities: [] },
      { name: '群馬県', path: '/gunma', cities: [] },
      { name: '埼玉県', path: '/saitama', cities: [{ name: 'さいたま市', path: '/saitama-city' }] },
      { name: '千葉県', path: '/chiba', cities: [{ name: '千葉市', path: '/chiba-city' }] },
      { name: '東京都', path: '/tokyo', cities: [] },
      { name: '神奈川県', path: '/kanagawa', cities: [
        { name: '横浜市', path: '/yokohama-city' },
        { name: '川崎市', path: '/kawasaki-city' },
        { name: '相模原市', path: '/sagamihara-city' },
      ] },
    ],
  },
  {
    name: '甲信越・北陸', path: '/hokuriku', prefectures: [
      { name: '新潟県', path: '/niigata', cities: [{ name: '新潟市', path: '/niigata-city' }] },
      { name: '富山県', path: '/toyama', cities: [] },
      { name: '石川県', path: '/ishikawa', cities: [] },
      { name: '福井県', path: '/fukui', cities: [] },
      { name: '山梨県', path: '/yamanashi', cities: [] },
      { name: '長野県', path: '/nagano', cities: [] },
    ],
  },
  {
    name: '東海', path: '/tokai', prefectures: [
      { name: '岐阜県', path: '/gifu', cities: [] },
      { name: '静岡県', path: '/shizuoka', cities: [
        { name: '静岡市', path: '/shizuoka-city' },
        { name: '浜松市', path: '/hamamatsu-city' },
      ] },
      { name: '愛知県', path: '/aichi', cities: [{ name: '名古屋市', path: '/nagoya-city' }] },
      { name: '三重県', path: '/mie', cities: [] },
    ],
  },
  {
    name: '近畿', path: '/kinki', prefectures: [
      { name: '滋賀県', path: '/shiga', cities: [] },
      { name: '京都府', path: '/kyoto', cities: [{ name: '京都市', path: '/kyoto-city' }] },
      { name: '大阪府', path: '/osaka', cities: [
        { name: '大阪市', path: '/osaka-city' },
        { name: '堺市', path: '/sakai-city' },
      ] },
      { name: '兵庫県', path: '/hyogo', cities: [{ name: '神戸市', path: '/kobe-city' }] },
      { name: '奈良県', path: '/nara', cities: [] },
      { name: '和歌山県', path: '/wakayama', cities: [] },
    ],
  },
  {
    name: '中国・四国', path: '/chugoku', prefectures: [
      { name: '鳥取県', path: '/tottori', cities: [] },
      { name: '島根県', path: '/shimane', cities: [] },
      { name: '岡山県', path: '/okayama', cities: [{ name: '岡山市', path: '/okayama-city' }] },
      { name: '広島県', path: '/hiroshima', cities: [{ name: '広島市', path: '/hiroshima-city' }] },
      { name: '山口県', path: '/yamaguchi', cities: [] },
      { name: '徳島県', path: '/tokushima', cities: [] },
      { name: '香川県', path: '/kagawa', cities: [] },
      { name: '愛媛県', path: '/ehime', cities: [] },
      { name: '高知県', path: '/kochi', cities: [] },
    ],
  },
  {
    name: '九州・沖縄', path: '/kyushu', prefectures: [
      { name: '福岡県', path: '/fukuoka', cities: [
        { name: '北九州市', path: '/kitakyushu-city' },
        { name: '福岡市', path: '/fukuoka-city' },
      ] },
      { name: '佐賀県', path: '/saga', cities: [] },
      { name: '長崎県', path: '/nagasaki', cities: [] },
      { name: '熊本県', path: '/kumamoto', cities: [{ name: '熊本市', path: '/kumamoto-city' }] },
      { name: '大分県', path: '/oita', cities: [] },
      { name: '宮崎県', path: '/miyazaki', cities: [] },
      { name: '鹿児島県', path: '/kagoshima', cities: [] },
      { name: '沖縄県', path: '/okinawa', cities: [] },
    ],
  },
];

export const Presentation: FunctionComponent = () => {
  return (
    <section className="sitetop-recruitment">
      <div className="sitetop-pickup-nav">
        <h2 className="sitetop-pickup-title">
          WORK LOCATION<span className="sitetop-pickup-sub">勤務地域から探す</span>
        </h2>
      </div>
      <div className="sitetop-location-container">
        {REGIONS.map((region) => (
          <div key={region.path} className="sitetop-location-container-box">
            <a href={region.path} className="sitetop-location-container-box-heading">
              {region.name}
            </a>
            <div className="sitetop-location-container-box-sp">
              {region.prefectures.map((pref) =>
                pref.cities.length > 0 ? (
                  <span key={pref.path}>
                    <a href={pref.path} className="sitetop-location-container-box-inner">
                      {pref.name}
                    </a>
                    <span className="round">（</span>
                    {pref.cities.map((city, ci) => (
                      <React.Fragment key={city.path}>
                        <a href={city.path} className="sitetop-location-container-box-inner">
                          {city.name}
                        </a>
                        {ci < pref.cities.length - 1 && <span className="round">、</span>}
                      </React.Fragment>
                    ))}
                    <span className="round">）</span>
                  </span>
                ) : (
                  <a key={pref.path} href={pref.path} className="sitetop-location-container-box-inner">
                    {pref.name}
                  </a>
                )
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
